import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { InputSelectInterface } from '@shared/components/form/input-select/input-select.interface';
import { FormControl, FormControlName, FormGroup, FormGroupDirective } from '@angular/forms';
import { MatSelectChange } from '@angular/material/select';
import { MyErrorStateMatcher } from '@services/MyErrorStateMatcher';

@Component({
  selector: 'app-input-select',
  templateUrl: './input-select.component.html',
  styleUrls: ['./input-select.component.scss'],
})
export class InputSelectComponent implements OnInit {
  @Input() label: string;
  @Input() required = false;
  @Input() placeholder: string;
  @Input() options: InputSelectInterface[];
  @Input() class?: string;
  @Input() behaviorSubjectOptions: string;
  @Input() customNameWithId = false;
  @Input() readOnly = false;
  @Output() handleChangeData = new EventEmitter();

  valueFormGroup?: FormGroup;
  valueFormControl?: FormControl;
  matcher = new MyErrorStateMatcher();

  constructor(private formGroupDirective: FormGroupDirective, private formControlNameDirective: FormControlName) {}

  get controlName() {
    return this.formControlNameDirective.name;
  }

  get enabled() {
    return this.valueFormControl?.enabled;
  }

  get valueControl() {
    return this.valueFormControl?.value;
  }

  get isNotValidAndDirty() {
    return !this.formControlNameDirective.valid && this.formControlNameDirective.dirty;
  }

  get hasErrors() {
    return this.formControlNameDirective.errors;
  }

  ngOnInit() {
    this.valueFormGroup = this.formGroupDirective.form;
    this.valueFormControl = this.formGroupDirective.getControl(this.formControlNameDirective);
    if (this.readOnly) this.valueFormControl.disable();
  }

  handleChangeValue = (e: MatSelectChange) => {
    this.handleChangeData.emit(e.value);
  };
}
